import { render, staticRenderFns } from "./BudgetModuleItem.vue?vue&type=template&id=83bc7e7e&scoped=true"
import script from "./BudgetModuleItem.vue?vue&type=script&lang=js"
export * from "./BudgetModuleItem.vue?vue&type=script&lang=js"
import style0 from "./BudgetModuleItem.vue?vue&type=style&index=0&id=83bc7e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bc7e7e",
  null
  
)

export default component.exports